import './App.css';
import {
  getPRID,
  clearPRID,
  getBanner,
  getMobile,
  getQueryString,
  addDataLayerEvent,
  transposeOffers,
  offerDataExpiredOrEmpty,
  getDisplayBannerProperties,
  getPridParam,
  getRedirectUrl
} from './lib/helpers'
import React from 'react';
import {
  Modal,
  ModalDescription,
  ModalContent,
  Image,
  Progress,
  Segment,
  Icon,
  Button,
  ModalActions
} from 'semantic-ui-react';
import moment from 'moment';
import {termsAndConditionsQA, termsAndConditionsPROD} from './constants';

function App() {

  const banner = getBanner();
  const isPridParam = getPridParam(); // we check if prid exists as a url parameter
  const hostname = window.location.hostname;
  const filePath = hostname.includes("localhost") || hostname.includes("web.app")?"/":"https://" + hostname + "/ab_myoffers_gallery/"
  const termsAndConditionsUrl = hostname.includes("localhost") || hostname.includes("qa") ? termsAndConditionsQA : termsAndConditionsPROD;

  const stores = [
    // { id: "all",
    //   name: "All",
    //   href: "https://qa.morerewards.ca/shop-my-offers",
    //   logo: filePath + "assets/img/mr_logo.svg"
    // },
    {
      id: "saveonfoods",
      name: "Save-On-Foods",
      href: "https://www.saveonfoods.com/shop-my-offers/?utm_campaign=myo_start_shopping&utm_medium=referral&utm_source=myoffers",
      logo: filePath + "assets/img/sof_logo.svg"
    },
    {
      id: "qualityfoods",
      name: "Quality Foods",
      href: "https://www.qualityfoods.com/?utm_campaign=myo_start_shopping&utm_medium=referral&utm_source=myoffers",
      logo: filePath + "assets/img/qf_logo.svg"
    },
    {
      id: "buylowfoods",
      name: "Buy-Low Foods",
      href: "https://www.buylowfoods.com/?utm_campaign=myo_start_shopping&utm_medium=referral&utm_source=myoffers",
      logo: filePath + "assets/img/blf_logo.svg"
    },
    {
      id: "nestersmarket",
      name: "Nesters Market",
      href: "https://www.nestersmarket.com/?utm_campaign=myo_start_shopping&utm_medium=referral&utm_source=myoffers",
      logo: filePath + "assets/img/nm_logo.svg"
    },
    {
      id: "pricesmartfoods",
      name: "PriceSmart Foods",
      href: "https://www.pricesmartfoods.com/?utm_campaign=myo_start_shopping&utm_medium=referral&utm_source=myoffers",
      logo: filePath + "assets/img/psf_logo.svg"
    },
    {
      id: "urbanfare",
      name: "Urban Fare",
      href: "https://www.urbanfare.com/?utm_campaign=myo_start_shopping&utm_medium=referral&utm_source=myoffers",
      logo: filePath + "assets/img/uf_logo.svg"
    },
  ];

  let bannerInHostname = false;

  // default banner is the first store in the list
  let defaultBanner = stores[0].id;

  // loop through the stores to see if the hostname includes the store id
  // if found then set the default banner to the store id and end the loop
  for (let i = 0; i < stores.length; i++) {
    if (hostname.includes(stores[i].id)) {
      defaultBanner = stores[i].id;
      bannerInHostname = true;
      break;
    }
  }

  // if banner exists then we show the filters and set the filter to the banner
  const defaultShowFilters = (banner || (bannerInHostname && banner !== 'all')) ? false : true;

  // check for the prid parameter in the url to set the selected offer
  const defaultPrid = getPRID();

  function getBannerUrl(banner) {
    const store = stores.find(store => store.id === banner);
    return store?stores.find(store => store.id === banner).href:"https://www.morerewards.ca/shop-my-offers";
  }

  function getBannerLogo(banner) {
    const store = stores.find(store => store.id === banner);

    let logo = filePath + "assets/img/mr_logo.svg";
    let name = "More Rewards";
    let className = banner + "_logo banner_logo";

    if (store) {
      logo = store.logo;
      name = store.name;
    }

    const alt = name + " logo";

    return (
        <img role="presentation" src={logo} alt={alt} title={alt} className={className}/>
    )
  }

  function setBannerFilter(banner) {
    setFilter(banner);
    const store = stores.find(store => store.id === banner);
    setStartShoppingUrl(getBannerUrl(store));
  }

  function getGTIN(digit) {
    function checkDigit(inputDigit) {
      var digit = inputDigit;
      if (inputDigit.length < 11) {
        // padleft with 0
        digit = "0".repeat(11 - inputDigit.length) + inputDigit;
      }

      var sumOdd = 0;
      var sumEven = 0;
      for (var i = 0; i < digit.length; i++) {
        if (i % 2 === 0) {
          sumOdd += parseInt(digit[i]);
        } else {
          sumEven += parseInt(digit[i]);
        }
      }

      sumOdd = sumOdd * 3;
      var result = sumOdd + sumEven;
      var checkDigit = 10 - (result % 10);

      return checkDigit;
    }
    var cd = checkDigit(digit);
    return (digit + cd).toString().padStart(14, "0");
  }

  // useState to set the state of the filter by storeId
  // if the banner parameter isn't available set the default filter to "saveonfoods" or check the cookie to see if
  const [filter, setFilter] = React.useState(banner && banner !== 'all' ? banner: defaultBanner);
  const [prid] = React.useState(defaultPrid ? defaultPrid : null);
  const [startShoppingUrl, setStartShoppingUrl] = React.useState(getBannerUrl(banner))
  const [open, setOpen] = React.useState(false);
  const [,setNotificationOpen] = React.useState(false);
  const [loaded, setLoaded] = React.useState(false);
  const [error, setError] = React.useState("");
  const [selectedOffer, setSelectedOffer] = React.useState({title: "", description: ""});

  let selectedDisplayBanner = ""
  let showSelectedDisplayBanner = false;
  let selectedDisplayBannerClass = "";
  if (selectedOffer.display_banner) {
    selectedDisplayBanner = selectedOffer.display_banner
    showSelectedDisplayBanner = selectedDisplayBanner && selectedDisplayBanner.trim() !== ""
    const display_bannerColor = getDisplayBannerProperties(selectedDisplayBanner).bannerColor
    selectedDisplayBannerClass = "ui label" + display_bannerColor
  }

  const modalSize = "tiny";

  const isMobileParam = getMobile();
  const queryString = getQueryString({banner: banner, mobile: isMobileParam});
  const authenticationUrl = getRedirectUrl(queryString, 'handle-prid');
  // + encodeURIComponent(window.location.protocol + '//' + window.location.host + window.location.pathname)

  const defaultOffers = [] // demoOffers

  const loadingTimeout = window.location.href.includes("localhost")?0:0; //2000
  const [offers, setOffers] = React.useState(defaultOffers);
  const [, setOffersLoaded] = React.useState(false);
  const [showFilters] = React.useState(defaultShowFilters);
  const [maintenance, setMaintenance] = React.useState(false);


  // useEffect pull offers from
  React.useEffect(() => {
    const handlePageShow = (event) => {
      if (event.persisted) {
        window.location.reload();
      }
    };

    window.addEventListener('pageshow', handlePageShow);

    if (!window.offersLoading && prid) {
      if (offerDataExpiredOrEmpty()) {
        window.offersLoading = true;
        addDataLayerEvent("offersLoadStart", {});
        fetch("https://api2.morerewards.ca/customer-offers-api/v1/Offers/customer/" + parseInt(prid) + "/offersEE", {
          "headers": {
            "accept": "application/json, text/plain, */*",
            "accept-language": "en-US,en;q=0.9",
            "cache-control": "no-cache",
            "pragma": "no-cache",
          },
          "referrer": "https://www.morerewards.ca",
          "referrerPolicy": "no-referrer-when-downgrade",
          "body": null,
          "method": "GET",
          "mode": "cors",
          "credentials": "omit",
        })
          .then(response => {
            if (!response.ok && response.status == 503) {
              setMaintenance(true);
              throw ({status: response.status, message: `Service Unavailable! status: ${response.status}`});
            }
            setMaintenance(false);
            return response.json();
          })
          .then(data => {
            // if there is a result key then we have an error state otherwise we received offers
            if (data.errorMessage) {
              let errorMessage = data.errorMessage;
              if (data.errorMessage === "Not found: Resource not found by identity name") {
                errorMessage = "We couldn't find your account in our system, id: " + prid;
              }
              setError(errorMessage);
            } else {
              // add the data to the offers state
              const newOffers = transposeOffers(data);

              if (newOffers.length === 0) {
                setError("No offers found for this account")
                return null
              }
              // sort offers by priority with lowest values first
              const sortedOffers = newOffers.sort((a, b) => a.priority - b.priority);

              const offerData = {prid: prid, timestamp: new Date().toISOString(), offers: sortedOffers};
              // store the offers in local storage
              localStorage.setItem("offers", JSON.stringify(offerData));

              setOffers(sortedOffers);//.concat(defaultOffers));
              setOffersLoaded(true);
              addDataLayerEvent("offersLoadComplete", {prid: prid, cache: false, offers: JSON.stringify(sortedOffers)});

              setTimeout(() => {
                setNotificationOpen(true);
                setLoaded(true);
              }, loadingTimeout);
            }
          })
          .catch (jsError => {
            let errorMessage;
            if (jsError.status === 503) {
              errorMessage = "New offers are being released.";
            } else {
              errorMessage = (JSON.stringify(jsError)) === "{}" ? "Our server seems to be having trouble." : JSON.stringify(jsError);
            }
            setError(errorMessage);
            addDataLayerEvent("offersLoadError", { error: JSON.stringify(jsError), response: errorMessage });
          });
      } else {
        const offerData = JSON.parse(localStorage.getItem("offers"));
        setOffers(offerData.offers);
        setOffersLoaded(true);
        addDataLayerEvent("offersLoadComplete", {prid: prid, cache: true, offers: JSON.stringify(offerData.offers)});

        setTimeout(() => {
          setNotificationOpen(true);
          setLoaded(true);
        }, loadingTimeout);

      }
    }
    else if (!prid && error === "") {
      addDataLayerEvent("offersLoadError", {error: "No PRID"});
      setLoaded(true);
    }
    return () => {
      window.removeEventListener('pageshow', handlePageShow);
    };
  }, []);


  function showOfferModal(offer) {
    addDataLayerEvent("offerClick", {offer: offer});
    setSelectedOffer(offer);
    setOpen(true);
  }

  function offerFilter(offer) {
    return offer.storeList.includes(filter) || offer.storeList.includes('allstores') || filter === 'all';
  }

  function continuityBar(offerType, redeemed, percent, target, value) {
    return (
      (offerType === "CONTINUITY" && !redeemed)?
        <div className="progress" aria-label='Progress towards redemption of this offer'>
          <Progress percent={percent} size="small">
            $ {value} / $ {target}
          </Progress>
        </div>
      :
        null
    );
  }

  const fallbackPage  = (pageType) => {
    const isMaintenance = pageType === 'maintenance';
    const image = isMaintenance ? 'maintenance.jpg' : 'sad_cat.png';
    const message = isMaintenance ? 'Offers are being updated! Please try again later to load the latest offers to your account.' : 'There was an error loading your offers. Please try again later.';
    const icon = isMaintenance ? 'wrench' : 'warning';
    return (
      <>
        {
          isMaintenance ?
            <div className="ui container notification maintenance-header">
              <div className="maintenance-banner-container">
                {getBannerLogo(banner)}
              </div>
              <div className="maintenance-svg-container">
              <svg role="presentation" className="myo_logo"
               alt="Logo of MyOffers. Pattison Food Group's loyalty and savings program." title="MyOffers logo"
               xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 63.08">
                <path className="letters"
                  d="M55.67,48.22L47.75,1.12c-.07-.63-.7-1.12-1.26-1.12h-1.12c-.35,0-.98.28-1.19.7l-16.26,30.28h-.14L11.51.7c-.21-.42-.84-.7-1.19-.7h-1.12c-.56,0-1.19.49-1.26,1.12L.02,48.22c-.14.91.49,1.54,1.33,1.54h8.27c.7,0,1.26-.56,1.33-1.12l3.08-21.66h.14l11.85,22.71c.21.42.77.77,1.19.77h1.26c.35,0,.98-.35,1.19-.77l11.78-22.71h.14l3.15,21.66c.07.56.7,1.12,1.33,1.12h8.27c.84,0,1.47-.63,1.33-1.54M98.01,2.73c.56-.91,0-2.03-1.12-2.03h-9.11c-.63,0-.91.35-1.12.63l-9.74,14.37-9.74-14.37c-.21-.28-.56-.63-1.12-.63h-9.11c-1.12,0-1.68,1.12-1.12,2.03l15.49,23.41v22.29c0,.7.56,1.33,1.33,1.33h8.34c.7,0,1.33-.63,1.33-1.33v-22.36l15.7-23.34ZM157.7,38.97c2.53-3.92,4.01-8.6,4.01-13.67,0-14.02-11.21-25.3-25.23-25.3s-25.16,11.28-25.16,25.3c0,12.96,9.53,23.44,22.05,24.96v-11.4c-6.16-1.44-10.83-6.99-10.83-13.56,0-7.71,6.31-14.09,13.95-14.09s14.02,6.38,14.02,14.09c0,1.9-.39,3.71-1.1,5.37l8.3,8.3ZM200.48,9.67V2.03c0-.7-.56-1.33-1.33-1.33h-29.02c-.77,0-1.33.63-1.33,1.33v46.4c0,.7.56,1.33,1.33,1.33h8.27c.7,0,1.33-.63,1.33-1.33v-17.03h15.98c.7,0,1.33-.63,1.33-1.33v-7.64c0-.7-.63-1.33-1.33-1.33h-15.98v-10.09h19.42c.77,0,1.33-.63,1.33-1.33M238.53,9.67V2.03c0-.7-.56-1.33-1.33-1.33h-29.02c-.77,0-1.33.63-1.33,1.33v46.4c0,.7.56,1.33,1.33,1.33h8.27c.7,0,1.33-.63,1.33-1.33v-17.03h15.98c.7,0,1.33-.63,1.33-1.33v-7.64c0-.7-.63-1.33-1.33-1.33h-15.98v-10.09h19.42c.77,0,1.33-.63,1.33-1.33M276.59,48.43v-7.64c0-.7-.56-1.33-1.33-1.33h-19.42v-9.46h15.98c.7,0,1.33-.56,1.33-1.33v-7.64c0-.7-.63-1.33-1.33-1.33h-15.98v-8.69h19.42c.77,0,1.33-.63,1.33-1.33V2.03c0-.7-.56-1.33-1.33-1.33h-29.02c-.77,0-1.33.63-1.33,1.33v46.4c0,.7.56,1.33,1.33,1.33h29.02c.77,0,1.33-.63,1.33-1.33M311.29,16.05c0,2.94-2.45,5.61-5.33,5.61h-10.37v-10.93h10.37c2.87,0,5.33,2.38,5.33,5.33M322.15,15.84c0-8.34-6.87-15.14-15.28-15.14h-20.96c-.77,0-1.33.63-1.33,1.33v46.4c0,.7.56,1.33,1.33,1.33h8.34c.7,0,1.33-.63,1.33-1.33v-17.87h4.84l9.32,18.57c.14.28.56.63,1.12.63h9.32c1.19,0,1.68-1.12,1.19-2.03l-9.6-17.8c6.1-2.45,10.37-7.64,10.37-14.09M358.6,7.5c.28-.49.42-1.75-.42-2.24-2.1-1.54-7.71-5.26-15-5.26-10.79,0-16.19,7.01-16.19,13.95,0,8.41,7.57,13.11,13.6,15.49,4.77,1.89,7.22,4.14,7.22,7.08,0,2.45-2.03,4.21-4.84,4.21-4.63,0-9.67-3.71-9.95-3.86-.49-.35-1.82-.49-2.38.42l-3.29,5.82c-.56.98-.35,1.26.35,1.96,1.61,1.61,6.66,5.4,15.77,5.4,10.3,0,16.54-7.29,16.54-14.51,0-9.53-8.69-13.81-14.16-15.98-5.54-2.24-7.64-4.21-7.64-6.8,0-1.89,1.89-3.57,4.42-3.57,4.28,0,9.39,3.86,10.02,4.21.63.49,1.89-.14,2.38-.91l3.57-5.4Z"/>
                <path className="arrow"
                  d="M159.43,49.65c.05-.42-.01-.88-.2-1.39-.19-.51-.43-.9-.71-1.19l-17.07-17.07c-.35-.33-.78-.56-1.29-.69-.51-.13-.95-.13-1.34,0-.39.13-.58.36-.58.69v26.7c0,.57.21,1.07.63,1.49.42.42.93.63,1.52.63l6.35-6.35,4.5,9.43c.26.51.67.86,1.22,1.06.55.2,1.1.17,1.64-.08.54-.25.91-.65,1.11-1.19.2-.54.17-1.08-.1-1.6l-4.7-9.79h8.4c.35,0,.56-.21.61-.63"/>
              </svg>
              </div>
            </div>
          :
            null
        }
        <div className="ui container maintenance">
          <Segment textAlign='center' warning='true' className='errorMessage'>
            <Icon name={icon}/>
              <span>{message}</span>&nbsp;
            <Icon name={icon}/>
            <Image alt="graphic depicting a computer with an error and a disappointed user"
                   src={filePath + `assets/img/${image}`}/>
            {
              isMaintenance ?
                <>
                  <p className='codeBlock'><code>{error}</code></p>
                </>
              :
                <>
                  <span>If you need immediate support - <a href="https://www.morerewards.ca/contact-us">contact us</a> and share this error message:</span>
                  <p className='codeBlock'><code>{error}</code></p>
                </>
            }
          </Segment>
        </div>
      </>
    )
  }


  function header() {
    return (
        <div className="ui container notification">
          <a href="#main" className="skip-to-main-content-link">Skip to main content</a>
          <div className="top-header">
            {getBannerLogo(banner)}
            {prid ?
                (isMobileParam && isMobileParam == 'true') || isPridParam ?
                  null // Do not display Sign Out button on mobile app
                :
                  <div className="mobile sign-out-container">
                    <a href='#' className='ui button signOut' role='button' aria-label='Sign out of Offer Gallery'
                       onClick={(event) => {
                         clearPRID(banner);
                         event.preventDefault();
                         return false
                       }}>SIGN OUT</a>
                  </div>
                :
                null // No prid. Do not display Sign Out button
            }
          </div>
          <div className='myoBlock'>
            <svg role="presentation" className="myo_logo"
                 alt="Logo of MyOffers. Pattison Food Group's loyalty and savings program." title="MyOffers logo"
                 xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 63.08">
              <path className="letters"
                    d="M55.67,48.22L47.75,1.12c-.07-.63-.7-1.12-1.26-1.12h-1.12c-.35,0-.98.28-1.19.7l-16.26,30.28h-.14L11.51.7c-.21-.42-.84-.7-1.19-.7h-1.12c-.56,0-1.19.49-1.26,1.12L.02,48.22c-.14.91.49,1.54,1.33,1.54h8.27c.7,0,1.26-.56,1.33-1.12l3.08-21.66h.14l11.85,22.71c.21.42.77.77,1.19.77h1.26c.35,0,.98-.35,1.19-.77l11.78-22.71h.14l3.15,21.66c.07.56.7,1.12,1.33,1.12h8.27c.84,0,1.47-.63,1.33-1.54M98.01,2.73c.56-.91,0-2.03-1.12-2.03h-9.11c-.63,0-.91.35-1.12.63l-9.74,14.37-9.74-14.37c-.21-.28-.56-.63-1.12-.63h-9.11c-1.12,0-1.68,1.12-1.12,2.03l15.49,23.41v22.29c0,.7.56,1.33,1.33,1.33h8.34c.7,0,1.33-.63,1.33-1.33v-22.36l15.7-23.34ZM157.7,38.97c2.53-3.92,4.01-8.6,4.01-13.67,0-14.02-11.21-25.3-25.23-25.3s-25.16,11.28-25.16,25.3c0,12.96,9.53,23.44,22.05,24.96v-11.4c-6.16-1.44-10.83-6.99-10.83-13.56,0-7.71,6.31-14.09,13.95-14.09s14.02,6.38,14.02,14.09c0,1.9-.39,3.71-1.1,5.37l8.3,8.3ZM200.48,9.67V2.03c0-.7-.56-1.33-1.33-1.33h-29.02c-.77,0-1.33.63-1.33,1.33v46.4c0,.7.56,1.33,1.33,1.33h8.27c.7,0,1.33-.63,1.33-1.33v-17.03h15.98c.7,0,1.33-.63,1.33-1.33v-7.64c0-.7-.63-1.33-1.33-1.33h-15.98v-10.09h19.42c.77,0,1.33-.63,1.33-1.33M238.53,9.67V2.03c0-.7-.56-1.33-1.33-1.33h-29.02c-.77,0-1.33.63-1.33,1.33v46.4c0,.7.56,1.33,1.33,1.33h8.27c.7,0,1.33-.63,1.33-1.33v-17.03h15.98c.7,0,1.33-.63,1.33-1.33v-7.64c0-.7-.63-1.33-1.33-1.33h-15.98v-10.09h19.42c.77,0,1.33-.63,1.33-1.33M276.59,48.43v-7.64c0-.7-.56-1.33-1.33-1.33h-19.42v-9.46h15.98c.7,0,1.33-.56,1.33-1.33v-7.64c0-.7-.63-1.33-1.33-1.33h-15.98v-8.69h19.42c.77,0,1.33-.63,1.33-1.33V2.03c0-.7-.56-1.33-1.33-1.33h-29.02c-.77,0-1.33.63-1.33,1.33v46.4c0,.7.56,1.33,1.33,1.33h29.02c.77,0,1.33-.63,1.33-1.33M311.29,16.05c0,2.94-2.45,5.61-5.33,5.61h-10.37v-10.93h10.37c2.87,0,5.33,2.38,5.33,5.33M322.15,15.84c0-8.34-6.87-15.14-15.28-15.14h-20.96c-.77,0-1.33.63-1.33,1.33v46.4c0,.7.56,1.33,1.33,1.33h8.34c.7,0,1.33-.63,1.33-1.33v-17.87h4.84l9.32,18.57c.14.28.56.63,1.12.63h9.32c1.19,0,1.68-1.12,1.19-2.03l-9.6-17.8c6.1-2.45,10.37-7.64,10.37-14.09M358.6,7.5c.28-.49.42-1.75-.42-2.24-2.1-1.54-7.71-5.26-15-5.26-10.79,0-16.19,7.01-16.19,13.95,0,8.41,7.57,13.11,13.6,15.49,4.77,1.89,7.22,4.14,7.22,7.08,0,2.45-2.03,4.21-4.84,4.21-4.63,0-9.67-3.71-9.95-3.86-.49-.35-1.82-.49-2.38.42l-3.29,5.82c-.56.98-.35,1.26.35,1.96,1.61,1.61,6.66,5.4,15.77,5.4,10.3,0,16.54-7.29,16.54-14.51,0-9.53-8.69-13.81-14.16-15.98-5.54-2.24-7.64-4.21-7.64-6.8,0-1.89,1.89-3.57,4.42-3.57,4.28,0,9.39,3.86,10.02,4.21.63.49,1.89-.14,2.38-.91l3.57-5.4Z"/>
            <path className="arrow" d="M159.43,49.65c.05-.42-.01-.88-.2-1.39-.19-.51-.43-.9-.71-1.19l-17.07-17.07c-.35-.33-.78-.56-1.29-.69-.51-.13-.95-.13-1.34,0-.39.13-.58.36-.58.69v26.7c0,.57.21,1.07.63,1.49.42.42.93.63,1.52.63l6.35-6.35,4.5,9.43c.26.51.67.86,1.22,1.06.55.2,1.1.17,1.64-.08.54-.25.91-.65,1.11-1.19.2-.54.17-1.08-.1-1.6l-4.7-9.79h8.4c.35,0,.56-.21.61-.63"/>
          </svg>
          {(loaded && prid)?
              <span role="heading" aria-level="2">
            All {offers.filter(offer => offerFilter(offer)).length} offers loaded to your account!
            <Icon name='check circle' className='large yellow' />
          </span>
              :
              (loaded)?
                  <span>
              Login to load your offers!
              <a href={authenticationUrl} role='button'>
                <Icon name='check circle' className='sign-in large yellow' />
              </a>
            </span>
                  :
                  (error === "")?
                      <span>
              Loading your exclusive offers!
                        {/* <div className="ui active inline small loader"></div> */}
            </span>
                      :
                      <span>
              There was an error loading your offers.
              <Icon name='exclamation circle' className='large yellow' />
            </span>
          }
        </div>
        {(loaded && prid)?
          <Segment textAlign='left' primary='true' size="huge">
            <span></span>
            {isMobileParam==="true"?
                null
              :
                isPridParam ?
                    null
                  :
                    <a href={startShoppingUrl} className='ui medium button startShopping large' role='button' aria-label='Link to start shopping on ecommerce'>START SHOPPING NOW</a>
            }
          </Segment>
        :
          (loaded)?
            <Segment textAlign='left' primary='true' size="huge">
              <span></span>
              <a href={authenticationUrl} className='ui button startShopping' role='button'>LOGIN TO LOAD</a>
            </Segment>
          :
            null
        }
      </div>
    )
  }

  function card(offer, index) {
    const {
      id,
      title,
      description,
      image,
      display_banner,
      leftMeta,
      continuityPercent,
      continuityTarget,
      continuityValue,
      redeemed,
      type
    } = offer

    const showdisplay_banner = display_banner && display_banner.trim() !== ""

    const display_bannerColor = getDisplayBannerProperties(display_banner).bannerColor

    const display_bannerClass = "ui ribbon label" + display_bannerColor
    const backgroundImage = "url(" + image + ")"
    // const formattedEndDate = moment(offer.endDate).format("MMM D, YYYY");


    return (
      <div key={"card_" + index + "_" + id} className="column" onClick={() => showOfferModal(offer)}>
        <div className={redeemed?"ui myoCard fluid link card raised redeemed":"ui myoCard fluid link card raised"}>
          {/* <div className="loaded"></div> */}
          <div className="image">
            { showdisplay_banner?
                <div className={display_bannerClass}><span aria-label='Offer category'>{display_banner}</span></div>:
                null
            }
            <div className="img" role="img" style={{backgroundImage: backgroundImage}}></div>
          </div>
          <div className="content">
            <div className="innerContent">
              <div className="header">{title}</div>
              <div className="description">{
                description.length > 50? description.substring(0, 50) + "...": description
              }</div>
              {continuityBar(type, redeemed, continuityPercent, continuityTarget, continuityValue)}
            </div>
            <div className="extra">
              <div className="offerRedeemed">{redeemed? <div className="ui mini label redeemedLabel" aria-label='Offer status'>Redeemed</div> : null}</div>
              <div className="offerTimer" aria-label='Duration remaining to redeem this offer'>{leftMeta}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  function doRedirect(url) {
    if (!window.redirecting) {
      setTimeout(() => {
        window.location = url
      }, 5000);
    }
    window.redirecting = true;
  }

  function placeholderCard(index) {
    return (
      <div key={"card_" + index} className="column">
        <div className="ui myoCard fluid link card raised">
          <div className="image">
            <div className="ui ribbon label">
              <span>⠀⠀⠀⠀⠀⠀⠀⠀⠀</span>
            </div>
            <div className='ui placeholder'>
              <div className="square image"></div>
            </div>
          </div>
          <div className="content">
            <div className="innerContent">
              <div className="ui placeholder">
                <div className="header">
                  <div className="very short line"></div>
                  <div className="medium line"></div>
                </div>
                <div className="paragraph">
                  <div className="short line"></div>
                </div>
              </div>
            </div>
            <div className="ui placeholder extra">
              <div className="paragraph">
                <div className="very short line"></div>
                {/* <div className="medium line"></div> */}
              </div>
            </div>
          </div>
        </div>
      </div>)
  }

  return (
    <div className="offerBody">
      { maintenance ?
          fallbackPage('maintenance')
        :
          <>
            <div className="wrapper">
              {
                (showFilters || banner === 'all') && loaded?
                  <div className="ui container">
                    <div className="ui myo_filters">
                      { stores.map(store =>
                        {
                          const storeId = "store_" + store.id;
                          const active = store.id === filter;
                          const className = active ? "ui button active" : "ui button basic";

                          return (
                              <button key={storeId} onClick={() => setBannerFilter(store.id)} id={storeId} className={className} role='contentinfo' alt={'Filter to show offers for ' + store.name} aria-label={'Filter to show offers for ' + store.name}>
                                {store.name}
                              </button>
                          )
                        }
                      )
                      }
                      {(prid && !isPridParam) && (isMobileParam === null || isMobileParam === 'false') ?
                        <div className="sign-out-container">
                          <a href='#' className='ui button signOut' role='button' aria-label='Sign out of Offer Gallery' onClick={(event) => {clearPRID(banner); event.preventDefault(); return false}}>SIGN OUT</a>
                        </div>
                      :
                        null
                      }
                    </div>
                  </div>
                :
                  null
              }
              {!loaded?
                <div>
                  {header()}
                  <div className="ui container loading-bar">
                    {error === ""?
                      null
                      // <div className="ui active inline text huge loader">Loading</div>
                    :
                      fallbackPage('sad_cat')
                    }
                  </div>
                  {error === ""?
                    <div id="main" className="card-list ui two tablet four column computer doubling grid container">
                      {
                        [0,1,2,3,4,5,6,7].map((index) => placeholderCard(index))
                      }
                    </div>
                  : null
                  }
                </div>
              :
                <div>
                  {(banner !== 'all' && banner !== null) && (isMobileParam === null || isMobileParam === 'false') && prid && !isPridParam ?
                      <div className="ui container banner-specific">
                        <div className="banner-specific sign-out-container">
                          <a href='#' className='ui button signOut' role='button' aria-label='Sign out of Offer Gallery' onClick={(event) => {clearPRID(banner); event.preventDefault(); return false}}>SIGN OUT</a>
                        </div>
                      </div>
                      :
                      null
                  }
                  {header()}
                  {
                    (!prid) ?
                      <div className='ui container'>
                        <Segment textAlign='center' warning='true' className='errorMessage'>
                          <h1 className='ui header'>
                            You need to be logged in
                            <div className='sub header'>
                              To load your exclusive offers!
                            </div>
                          </h1>

                          <p>We're going to automatically redirect you in 5 seconds or you can click the "Login To Load".</p>
                          <a href={authenticationUrl} className='ui button startShopping' role='button'>LOGIN TO LOAD</a>
                          <div style={{display: "none"}}>
                            {
                              doRedirect(authenticationUrl)
                            }
                          </div>
                        </Segment>
                      </div>
                    :
                      <div id="main" className="card-list ui two tablet four column computer doubling grid container">
                        {
                          offers.filter(offer => offerFilter(offer)).map((offer, index) =>
                              card(offer, index)
                          )
                        }
                      </div>
                  }
                </div>
              }
              <Modal
                size={modalSize}
                onClose={() => setOpen(false)}
                onOpen={() => setOpen(true)}
                open={open}
                closeIcon
                aria-modal="true"
                role="dialog"
              >

                <ModalContent image={true}>
                  <Image size='small' src={selectedOffer.image} wrapped={true} />
                  <ModalDescription>
                    <h2>{selectedOffer.title}</h2>
                    <p>{selectedOffer.description}</p>
                    <p><strong>Valid until:</strong><br /> {moment(selectedOffer.endDate).format("MMM D, YYYY")} - {selectedOffer.leftMeta}</p>
                    {/* {selectedOffer.eligibleProducts && selectedOffer.eligibleProducts.length !== 0?
                  <div class="eligibleProductList">
                    <strong>Eligible Products:</strong>
                    <ul>
                      {selectedOffer.eligibleProducts.map(product => <li>{getGTIN(product)}</li>)}
                    </ul>
                  </div>
                  : null
                } */}
                    <p className="progress">
                      {selectedOffer.redeemed?
                        <div className="ui tiny label redeemedLabel grey">Redeemed</div>:
                        null
                      }
                    </p>
                    {
                      continuityBar(
                        selectedOffer.type,
                        selectedOffer.redeemed,
                        selectedOffer.continuityPercent,
                        selectedOffer.continuityTarget,
                        selectedOffer.continuityValue
                      )
                    }
                    {showSelectedDisplayBanner?
                      <div className={selectedDisplayBannerClass}>{selectedDisplayBanner}</div>
                      :null
                    }
                  </ModalDescription>
                </ModalContent>
                <ModalContent>
                  <ModalDescription>
                    {selectedOffer.terms_and_conditions && selectedOffer.terms_and_conditions.trim() !== ""?
                      <p>
                        <strong>Terms and Conditions:</strong><br />
                        {selectedOffer.terms_and_conditions}
                      </p> : null}</ModalDescription>
                </ModalContent>
                <ModalActions>
                  <Button aria-label='Close the popup' role='button' alt="Close the popup" onClick={() => setOpen(false)}>Close</Button>
                </ModalActions>
              </Modal>
            </div>
            <div id="terms-and-conditions" className="ui container mmd-text">
              <p>My Mega Deal is a personalized offer which is subject to availability and may not be available to all More
                Rewards members/households. <a href={termsAndConditionsUrl} target="_blank">Terms and Conditions</a> Apply.
                <br /><br />Certain attributes of the More Rewards program, including My Offers digital coupons, are not available in the Buy-Low Foods Prince George, Grande Prairie and Nanaimo locations. See in-store for full details.
              </p>
            </div>
          </>
      }
      <div className='footer'>
        <div className='ui container vertical'>
          <div className='ui secondary menu'>
            <div className='entity'>
              Pattison Food Group Ltd. | 19855 - 92A Avenue, Langley, BC, Canada, V1M 3B6
            </div>
            <div className='right menu'>
              <a href='https://pattisonfoodgroup.com/privacy-policy' rel="noreferrer noopener" target='_blank' aria-label='Link to the Pattison Food Group privacy policy' className='item'>Privacy</a>
              <a href={termsAndConditionsUrl} rel="noreferrer noopener" target='_blank' aria-label='Link to the assorted terms of use across More Rewards and Pattison Food Group' className='item'>Terms</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
